<ng-container *ngIf="data.form">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <ng-container *ngFor="let name of names">
            
            <mat-form-field>
                <mat-label >{{ name.message }}</mat-label>
                <input matInput [formControlName]="name.control">
            </mat-form-field>
    
        </ng-container>
    
        <button type="submit" class="btn btn-primary submit">Enregistrer</button>
    
    </form>
</ng-container>

